import { Competition, Nullable, Profile } from "@brg/api";
import React from "react";

export type RequestFilterT = {
    competitionId: string;
    projectId: string;
    competitionStatus: number[];
    competitionIds: Nullable<string[]>;
    profile: Profile;
    lang: string;
    disableRequest?: boolean;
}

interface IProps {
    requestFilter?: RequestFilterT;
    currentList: Record<string, any>[];
    criteriaList: Record<string, any>[];
    nextCriteriaList: Record<string, any>[];
    prevCriteriaList: Record<string, any>[];
    prevCriteriaId: string; 
    nextCriteriaId?: string;
    voteEnd: string;
    currentCompId: string;
    disableNext: boolean;
    projectId: string;
    voiseSet: boolean;
    isLoading: boolean;
    isNextLoading: boolean;
    errorMessage?: string;
    competitions: Competition<'Local'>[];
    hasData?: boolean;
    onToggleStatus: (flag: boolean) => void;
    resetData: () => void;
    updateData: () => void;
    setFilter: (data: RequestFilterT) => void;
    setVote: (data: any) => void;
}

export const initialContext: IProps = {
    requestFilter: undefined,
    currentList: [],
    criteriaList: [],
    nextCriteriaList: [],
    prevCriteriaList: [],
    prevCriteriaId: '',
    nextCriteriaId: undefined,
    voiseSet: false,
    isLoading: false,
    isNextLoading: false,
    disableNext: false,
    hasData: false,
    voteEnd: 'inProgress',
    errorMessage: '',
    currentCompId: '',
    competitions: [],
    projectId: '',
    resetData: () => {},
    updateData: () => {},
    onToggleStatus: (flag: boolean) => {},
    setFilter: (data: RequestFilterT) => {},
    setVote: (data: any) => {}
};

const VoteContext = React.createContext(initialContext);

export default VoteContext;
import { Competition, Nullable, Profile } from "@brg/api";
import React from "react";

export type RequestFilterT = {
    competitionId: string;
    projectId: string;
    competitionStatus: number[];
    competitionIds: Nullable<string[]>;
    profile: Profile;
    lang: string;
    disableRequest?: boolean;
}

interface IProps {
    requestFilter?: RequestFilterT;
    currentList: Record<string, any>[];
    criteriaList: Record<string, any>[];
    nextCriteriaList: Record<string, any>[];
    prevCriteriaList: Record<string, any>[];
    prevCriteriaId: string; 
    nextCriteriaId?: string;
    voteEnd: string;
    currentCompId: string;
    disableNext: boolean;
    projectId: string;
    voiseSet: boolean;
    isLoading: boolean;
    isNextLoading: boolean;
    errorMessage?: string;
    competitions: Competition<'Local'>[];
    hasData?: boolean;
    onToggleStatus: (flag: boolean) => void;
    resetData: () => void;
    updateData: () => void;
    setFilter: (data: RequestFilterT) => void;
    setVote: (data: any) => void;
}

export const initialContext: IProps = {
    requestFilter: undefined,
    currentList: [],
    criteriaList: [],
    nextCriteriaList: [],
    prevCriteriaList: [],
    prevCriteriaId: '',
    nextCriteriaId: undefined,
    voiseSet: false,
    isLoading: false,
    isNextLoading: false,
    disableNext: false,
    hasData: false,
    voteEnd: 'inProgress',
    errorMessage: '',
    currentCompId: '',
    competitions: [],
    projectId: '',
    resetData: () => {},
    updateData: () => {},
    onToggleStatus: (flag: boolean) => {},
    setFilter: (data: RequestFilterT) => {},
    setVote: (data: any) => {}
};

const VoteContext = React.createContext(initialContext);

export default VoteContext;
